// covered-by: frontends/carrie/src/ask-v2/services/__tests__/projects.test.ts
import { type CreateAskPunttProjectResponse } from "@mg/schemas/src/christo/askPunttProject";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

const projectsUrl = `${API_URL}/private/catalyst/ask-puntt/projects`;

export async function createAskV2Project(payload: {
  name: string;
  description?: string;
  context?: string;
  upcomingWork?: string;
}): Promise<CreateAskPunttProjectResponse> {
  const json = await smartFetch(projectsUrl, {
    method: "POST",
    // why: V2 is always warhol; the shared-chat agent is decided at create.
    body: JSON.stringify({ ...payload, agent: "warhol" }),
  });
  return json as CreateAskPunttProjectResponse;
}
